import React, { createContext, useContext, useState, useEffect } from 'react';
import themes from '../layout/themes';

const ThemeContext = createContext();

export const themeList = ['blue', 'navy', 'abyss', 'darkgreen', 'green', 'olive', 'rose', 'burgundy', 'maroon'];

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('navy');

  useEffect(() => {
    const root = document.documentElement;
    const themeVariables = themes[theme];
    Object.keys(themeVariables).forEach(variable => {
      root.style.setProperty(variable, themeVariables[variable]);
    });
  }, [theme]);

  const getNextTheme = () => {
    const currentIndex = themeList.indexOf(theme);
    if (currentIndex === -1) {
        return null;
    }
    const nextIndex = (currentIndex + 1) % themeList.length;
    return themeList[nextIndex];
  }

  const switchTheme = (themeName) => {
    if(!themeName) {
      themeName = getNextTheme();
    }
    // console.log("themeName", themeName)
    setTheme(themeName);
  };

  return (
    <ThemeContext.Provider value={{ theme, switchTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

// export const tanstackTableTheme = theme === "light" ? "bg-primary/10 hover:bg-primary/10 text-primary font-bold" : "bg-primary hover:bg-primary text-white font-bold";
export const tanstackTableTheme = "bg-primary/10 hover:bg-primary/10 text-primary font-bold";
